import { render, staticRenderFns } from "./VideoComponentPcm.vue?vue&type=template&id=50855cb8&scoped=true"
import script from "./VideoComponentPcm.vue?vue&type=script&lang=js"
export * from "./VideoComponentPcm.vue?vue&type=script&lang=js"
import style0 from "./VideoComponentPcm.vue?vue&type=style&index=0&id=50855cb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50855cb8",
  null
  
)

export default component.exports